import { openDB, type IDBPDatabase } from "idb";

const DB_NAME = "deeply-smart-rq-persist";
const STORE = "kv";
const DB_VERSION = 1;

let dbPromise: Promise<IDBPDatabase> | null = null;

function getDb(): Promise<IDBPDatabase> {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE)) {
          db.createObjectStore(STORE);
        }
      },
    });
  }
  return dbPromise;
}

/** AsyncStorage shape for TanStack `createAsyncStoragePersister`. */
export const rqIdbStorage = {
  getItem: async (key: string): Promise<string | null> => {
    const db = await getDb();
    const v = await db.get(STORE, key);
    return typeof v === "string" ? v : v == null ? null : String(v);
  },
  setItem: async (key: string, value: string): Promise<void> => {
    const db = await getDb();
    await db.put(STORE, value, key);
  },
  removeItem: async (key: string): Promise<void> => {
    const db = await getDb();
    await db.delete(STORE, key);
  },
};
